import { APIURL } from "./../Constantes";
import {AUTH_CREDENTIALS_NAME} from "./../Constantes"
export default async function ApiCall({ url = "", method = "get", body }) {
  let Token = localStorage.getItem(AUTH_CREDENTIALS_NAME);
  try {
    const response = await fetch(`${APIURL}/${url}`, {
      method,
      body,
      headers: {
        Authorization: `bearer ${Token}`,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });
    return response;
  } catch (error) {
    Promise.reject(error);
  }
}
